import React from "react";
import axios from "axios";
import SideBar from "../SideBar";
import Header from "../Header";

class EditBrand extends React.Component {
  constructor() {
    super();
    this.state = {
      user: "",
      brandName: "",
      userType: "vendor",
      loading: false,
    };
  }

  handleInputChange = (event) => {
    this.setState({ [event.target.id]: event.target.value });
  };
  requestBodyBuilder = () => {
    var data = {
      id: this.state.id,
      brandName: this.state.brandName,
    };
    return data;
  };

  submitOrder = (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    let config = { headers: { authorization: `Token ${this.state.token}` } };
    var data = this.requestBodyBuilder();
    axios
      .put(`${process.env.REACT_APP_API_URL}brand/update`, data, config)
      .then((res) => {
        if (res) {
          this.props.history.push("/admin/view-brands");
        }
      })
      .catch(({ response }) => this.setState({ loading: false }));
  };

  populateData = (data) => {
    this.setState({
      brandName: data.brandName,
    });
  };

  componentDidMount() {
    var user = localStorage.getItem("user");
    var userData = JSON.parse(user);
    let id = this.props.match.params.id;
    this.setState({ id: id });
    if (userData) {
      this.setState({ user: userData, token: userData.token, id: id });
      let config = {
        headers: { authorization: `Token ${user.token}` },
        params: { id: id },
      };
      axios
        .get(`${process.env.REACT_APP_API_URL}brand/getbrand/`, config)
        .then((res) => {
          if (res.data.brand[0]) {
            this.populateData(res.data.brand[0]);
          }
        });
    }
  }

  render() {
    return (
      <>
        <Header />
        <div className="container-fluid">
          <div className="row">
            <SideBar />
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2 fw-bold">Edit Brand</h1>
              </div>

              <div className="col-md-6">
                <form onSubmit={(event) => this.submitOrder(event)}>
                  <div className="form-outline mb-4">
                    <label className="form-label" htmlFor="weight">
                      Brand Name
                    </label>
                    <input
                      type="text"
                      id="brandName"
                      className="form-control"
                      name="brandName"
                      value={this.state.brandName}
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary2 btn-block mb-4"
                    disabled={this.state.loading}
                  >
                    Edit Brand
                  </button>
                </form>
              </div>
            </main>
          </div>
        </div>
      </>
    );
  }
}

export default EditBrand;
